import { render, staticRenderFns } from "./CoachAwardSvg.vue?vue&type=template&id=ebe3e340&"
import script from "./CoachAwardSvg.vue?vue&type=script&lang=js&"
export * from "./CoachAwardSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports